import { SelectionMode } from "@fluentui/react";
import { observer } from "mobx-react";
import * as React from "react";
import { store } from "../store";
import { Section } from "../ui/atoms/section";

import { ListVehicleMovementPeriods } from "../ui/molecules/list-vehicle-movement-periods";
import sizes from "../ui/sizes.scss";
import { articles } from "../help";
import { FusionLayout } from "@/parts/fusion-layout";

@observer
export class PageVehicleMovementPeriods extends React.Component {
    public render(): JSX.Element {
        return (
            <FusionLayout
                suggestedHelpArticles={[articles.truckFleetDriveTimeReport]}
                breadcrumb={store.i18n.t("page.vehicleMovementPeriods.title")}
                classic
            >
                <Section fill>
                    <ListVehicleMovementPeriods
                        selectionMode={SelectionMode.none}
                        maxHeight={`${sizes.listMaxHeight}`}
                    />
                </Section>
            </FusionLayout>
        );
    }
}
